import { Table, TableCol, TablePagination } from 'zens-storybook'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ViewProps } from 'react-native'
import { useCompanies, useStore, Company } from 'zens-store'
import { CompanyEmpty } from '@dms/component'

import { TablePaginated } from '../table'

interface Props extends ViewProps {
  cols: TableCol<Company>[]
  search?: string
  pagination?: TablePagination
  onPaginationChange?: (pagination: TablePagination) => void
}

const CompanyTable = (props: Props) => {
  const { cols, search, pagination = { page: 0, size: 10 }, onPaginationChange, ...otherProps } = props
  const { message } = useStore()
  const { t } = useTranslation()
  const companies = useCompanies({ search })
  useEffect(() => {
    if (companies.isError) {
      const { message: errorMessage } = companies.error as Error
      console.debug(`COMPANY: Companies load failed: ${errorMessage}`)
      message.add({
        message: `${t('Companies data could not be loaded')}. ${errorMessage}`,
        status: 'error',
      })
    }
  }, [companies.isError])

  const rows =
    companies.data?.map((company) => ({
      data: company,
      href: `/companies/${company.id}`,
    })) || []

  return (
    <TablePaginated
      rows={rows}
      cols={cols}
      pagination={pagination}
      count={rows.length}
      renderCount={() =>
        t('{{page}} of {{numberOfPages}}', {
          page: pagination.page + 1,
          numberOfPages: Math.ceil(rows.length / pagination.size),
        })
      }
      sizeLabel={t('Companies per page')}
      maxSize={1000}
      onPaginationChange={onPaginationChange}
      sort={{ field: 'name' }}
      ListEmptyComponent={<CompanyEmpty search={search} />}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {
  cols: TableCol<Company>[]
}
CompanyTable.Skeleton = (props: SkeletonProps) => <Table.Skeleton hasAccessory {...props} />

export default CompanyTable
